import { type ReactElement, useState } from 'react';

import { useDentistsContext } from '../';
import { type City, getCities } from '../../../services/StatesService';
import { Select } from '../../Select';

const toUpperText = (value: any) =>
  typeof value === 'string' ? value.toLocaleUpperCase('pt-BR') : value || '';

export default function PlanForm(): ReactElement {
  const [cities, setCities] = useState<City[]>([]);
  const [loadingCep, setLoadingCep] = useState(false);

  const {
    states,
    state,
    city,
    bairros,
    bairro,
    cep,
    resolvedAddress,
    setCity,
    setState,
    setBairro,
    setCep,
    lookupCep,
  } = useDentistsContext();

  function submitForm(event) {
    event.preventDefault();
  }

  async function onCepChange(event) {
    const value = event.target.value;
    setCep(value);

    if (value.replace(/\D/g, '').length === 8) {
      setLoadingCep(true);
      try {
        await lookupCep(value);
      } finally {
        setLoadingCep(false);
      }
    }
  }

  function onStateChange(event) {
    const ID = event.target.value;
    setCity(null);
    setBairro('');
    getCities(ID).then(cities => {
      setCities(
        cities.map(city => ({
          ...city,
          Sigla: toUpperText(city.Sigla),
          Descricao: toUpperText(city.Descricao),
        })),
      );
    });
    setState(states.find(s => s.Id === +ID));
  }

  function onCityChange(event) {
    setBairro('');
    setCity(cities.find(c => c.Id === +event.target.value));
  }

  return (
    <div className="w-full">
      <h3 className="mb-4 text-xl font-medium text-high-emphasis max-[1300px]:text-lg">
        Onde voce gostaria de ser atendido?
      </h3>
      <form id="dentist-search-plan-form" onSubmit={submitForm}>
        <div className="grid grid-cols-1 gap-4 min-[900px]:grid-cols-[minmax(180px,0.8fr)_1fr_1fr_1fr]">
          <fieldset className="flex flex-col gap-1">
            <label htmlFor="dentist-search-cep" className="text-high-emphasis">
              CEP
            </label>
            <input
              id="dentist-search-cep"
              value={cep}
              onChange={onCepChange}
              inputMode="numeric"
              maxLength={9}
              placeholder="Digite seu CEP"
              className="h-12 w-full rounded-lg border border-neutral-lighter px-4 py-3 text-medium-emphasis outline-none focus:ring-1 focus:ring-primary-main"
            />
          </fieldset>

          <Select
            label="Estado"
            placeholder="Estado"
            options={[]}
            value={state?.Id || ''}
            optionsFull={states}
            onChange={onStateChange}
          />

          <Select
            label="Cidade"
            placeholder="Cidade"
            value={city?.Id || ''}
            onChange={onCityChange}
            options={[]}
            optionsFull={cities.length ? cities : city ? [city] : []}
          />

          <Select
            label="Bairro"
            placeholder="Todos os bairros"
            enablePlaceholder
            value={bairro || ''}
            onChange={e => setBairro(e.target.value)}
            options={[]}
            optionsFull={bairros}
          />
        </div>

        {(loadingCep || resolvedAddress) && (
          <p className="mt-2 text-sm text-primary-main">
            {loadingCep ? 'BUSCANDO ENDERECO...' : toUpperText(resolvedAddress)}
          </p>
        )}
      </form>
    </div>
  );
}
